const SET_COMPANY = 'setCompany'

export const mutationTypes = {
  SET_COMPANY
}

export const mutations = {
  [SET_COMPANY] (state, payload) {
    state.company = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/module/company/mutations.js